<template>
    <div>
        <p class="little-label">功能授权：</p>
        <AuthChooseItem v-for='(item,index) in whProduct' :key='index' :name='item.wenpname' @click='click(item)'
            :selected='item.wenhuapid == $route.params.id || $route.name == "Preview"'
            :detailName="item.pname"
            :link="item.link"
            :disable='$route.name == "Preview"' />
            <span v-if="$route.params.id == 128" style="color:rgb(111, 111, 113);position: relative;top:20px;margin-left:15px;">*用户购买5C功能后，延续使用原有账号，只是授权发生改变</span>
        <template v-if='canOrderByMonth || canOrderByQuarter'>
            <div class="line-dot"></div>
            <p class="little-label">支付方式:</p>
            <AuthChooseItem v-for='(item) in deadLine' :key='item.name' :name='item.name' @click="chooseLimit(item)"
                :selected='item.selected' :disable='item.disable ||  $route.name == "Preview"' />
        </template>
        <div class="line-dot"></div>
        <p v-show="hasChooseAuth" class="little-label">选配{{isWH10 || isWH11? "数据" : "授权"}}：</p>
        <AuthChoose ref='choosen' :preClick='preClick' :authConfigData='data' :isMonth='isOrderByMonth' />
        <div v-show="hasChooseAuth" class="line-dot"></div>
        <p style='padding-top: 0px;' class="little-label">已勾选：{{authNames}}</p>
    </div>
</template>

<script>
    import wh from '@/assets/js/wh.js'
    export default {
        name: 'new-buy',
        components: {

        },
        inject: ['orderByMonth', 'orderByYear', 'orderByQuarter'],
        provide() {
            let self = this
            return {
                selectAuthItem(x) {
                    self.selectData = JSON.parse(JSON.stringify(x.filter(v => !v
                        .isChecked))) //isChecked为默认选中，目前默认选中的不计入产品ids
                    var auth = self.whProduct ? self.whProduct.filter(v => v.wenhuapid == self.$route.params.id).map(
                        v => v.wenpname) : []
                    self.authNames = auth.concat(x.map(v => v.name || v.productName)).join('+')
                },
                fatherType() {
                    return 'new'
                }
            }
        },
        props: {
            data: Array,
            whProduct: Array,
            canOrderByMonth: {
                default: false,
                type: Boolean
            },
            canOrderByQuarter: {
                default: false,
                type: Boolean
            },
        },
        data: () => ({
            chooseData: [],
            authNames: '',
            selectData: [],
            deadLine: [{
                    name: '按年支付',
                    value: 1,
                    selected: true,
                    disable: false
                },
                {
                    name: '按季支付',
                    value: 2,
                    selected: false,
                    disable: true
                },
                {
                    name: '按月支付',
                    value: 0,
                    selected: false,
                    disable: true
                },

            ],
            memoryAuthSelelctions: []
        }),
        computed: {
            hasMajor() {
                let flag = -1
                this.selectData.forEach(v => {
                    if (v.cmajor === 1 && v.productlink && (!v.productlink.includes('EUREX') && !v.productName
                            .includes('香港'))) {
                        flag = 1
                    } else if (v.cmajor === 0 && v.productlink && (!v.productlink.includes('EUREX') && !v
                            .productName.includes('香港'))) {
                        flag = 0
                    }
                })
                return flag
            },
            hasOgz() {
                let flag = -1
                this.selectData.forEach(v => {
                    if (v.cmajor === 1 && v.productlink && (v.productlink.indexOf('EUREX') >= 0 || v.productName
                            .indexOf('香港') >= 0)) {
                        flag = 1
                    } else if (v.cmajor === 0 && v.productlink && (v.productlink.indexOf('EUREX') >= 0 || v
                            .productName.indexOf('香港') >= 0)) {
                        flag = 0
                    }
                })
                return flag
            },
            hasOut() {
                let flag = false
                this.selectData.forEach(v => {
                    if (v.grouptype == 1 || v.grouptype == 2 || v.grouptype == 3 || v.grouptype == 4) {
                        flag = true
                    }
                })
                return flag
            },
            selectIds() {
                return this.selectData.map(v => v.id).join(',')
            },
            orderLimit() {
                let target = this.deadLine.find(v => v.selected)
                if (target) {
                    return target.value
                } else {
                    return -1
                }
            },
            isOrderByMonth() {
                return this.deadLine.find(v => v.value == 0).selected
            },
            isOrderByQuarter() {
                return this.deadLine.find(v => v.value == 2).selected
            },
            hasHistoryData () {
                return this.$refs.choosen.hasHistoryData
            },
            isWH10 () {
                return ['110','125', '126', '128', '129', '138'].includes(this.$route.params.id)
            },
            isWH11 () {
                return ['131'].includes(this.$route.params.id)
            },
            hasChooseAuth () {
                return !this.isWH11 && !this.isWH10
            }
        },
        watch: {
            canOrderByMonth: {
                handler (val) {
                    let index = this.deadLine.findIndex(v => v.value == 0)
                    this.$set(this.deadLine[index], 'disable', false)
                },
                immediate: true
            },
            canOrderByQuarter: {
                handler (val) {
                    let index = this.deadLine.findIndex(v => v.value == 2)
                    this.$set(this.deadLine[index], 'disable', false)
                },
                immediate: true
            },
        },
        mounted() {

        },
        methods: {
            click(item) {
                if(item.wenhuapid == this.$route.params.id && this.whProduct.length == 1) return
                this.$router.push({
                    path: '/Detail/' + item.wenhuapid
                })
                this.$store.commit('renewbuy/setCrossFlag', false)
                this.$store.commit('addbuy/setCrossFlag', false)
            },
            chooseLimit(item) {
                if (item.selected) return
                this.deadLine.forEach(v => {
                    if (v.value == item.value) {
                        this.$set(v, 'selected', true)
                    } else {
                        this.$set(v, 'selected', false)
                    }
                })
                if (item.value == 0) {
                    //按月购买
                    if (!this.memoryAuthSelelctions || this.memoryAuthSelelctions.length == 0) {
                        this.memoryAuthSelelctions = wh.disDeepClone(this.$refs.choosen
                        .getSelections()) //.filter(v=> v.name != "多账号下单模块") //切换到按月之前记录之前选过的子授权
                    }
                    console.log(this.memoryAuthSelelctions)
                    this.orderByMonth()
                    this.$refs.choosen.cancelEach(v => /*v.name != "多账号下单模块"*/ true)
                    this.$refs.choosen.setDisableEach(v => {
                        return /*v.name == "多账号下单模块" ? false : */ true
                    })
                } else if (item.value == 1) {
                    //按年购买
                    this.orderByYear()
                    this.$refs.choosen.setDisableEach(v => false)
                    if (this.memoryAuthSelelctions) { //如果之前有记录过的子授权，重新将其选中，并清除记录
                        this.$refs.choosen.selectItemsById(this.memoryAuthSelelctions)
                        this.$nextTick(() => {
                            this.memoryAuthSelelctions = null
                        })
                    }
                } else if (item.value == 2) {
                    //按季购买
                    if (!this.memoryAuthSelelctions || this.memoryAuthSelelctions.length == 0) {
                        this.memoryAuthSelelctions = wh.disDeepClone(this.$refs.choosen
                        .getSelections()) //.filter(v=> v.name != "多账号下单模块") //切换到按月之前记录之前选过的子授权
                    }
                    this.orderByQuarter()
                    this.$refs.choosen.cancelEach(v => /*v.name != "多账号下单模块"*/ true)
                    this.$refs.choosen.setDisableEach(v => {
                        return /*v.name == "多账号下单模块" ? false : */ true
                    })
                }
            },
            preClick() {
                if (this.orderLimit == -1 && this.canOrderByMonth) {
                    this.$market.alert({
                        content: '请选则支付方式'
                    })
                    return true
                } else {
                    return false
                }
            }
        }
    }
</script>

<style scoped>
    .little-label {
        font-size: 12px;
        color: rgb(111, 111, 113);
        clear: both;
        padding: 0 0 4px;
        margin: 0;
    }

    .line-dot {
        border-bottom: 1px dashed rgb(136, 137, 138);
        clear: both;
        padding-top: 10px;
        margin-bottom: 10px;
    }

    .choose_item {
        float: left;
    }
</style>